<template>
<div class="CommissionDaily" v-if="init">
    <div class="summary">
        <div class="box bgc box-shadow">
            <div class="name">今日产生佣金</div>
            <div class="value">￥{{summary.todaybrokeragetotalbyheader}}</div>
        </div>
        <div class="box bgc box-shadow">
            <div class="name">今日已发佣金</div>
            <div class="value">￥{{summary.todaybrokeragepayed}}</div>
        </div>
        <div class="box bgc box-shadow">
            <div class="name">昨日产生佣金</div>
            <div class="value">￥{{summary.yesbrokeragetotalbyheader}}</div>
        </div>
        <div class="box bgc box-shadow">
            <div class="name">昨日已发佣金</div>
            <div class="value">￥{{summary.yesbrokeragepayed}}</div>
        </div>
    </div>
    <div class="total bgc">
        <div class="left">
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <div class="name">
                            <span>产生佣金</span>
                        </div>
                        <div class="value tc-blue">￥{{summary.brokeragetotalbyheader}}</div>
                    </div>
                    <div class="box">
                        <div class="name">
                            <span>已发佣金</span>
                        </div>
                        <div class="value tc-green">￥{{summary.brokeragepayed}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="filters bgc">
                <div class="add">
                    <el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">
                        今天
                    </el-button>
                    <el-button type="primary" @click="handleQuery(2)"
                               :class="[param.timetype!=2?'is-disabled': '']">昨天
                    </el-button>
                    <el-button type="success" @click="handleQuery(3)"
                               :class="[param.timetype!=3?'is-disabled': '']">近7天
                    </el-button>
                    <el-button type="warning" @click="handleQuery(4)"
                               :class="[param.timetype!=4?'is-disabled': '']">近30天
                    </el-button>
                </div>
                <div class="search">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="success" @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div class="echert">
                <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
            </div>
        </div>
    </div>
    <div class="list bgc">
        <div class="result-list btn-operate-list bgc">
            <div class="tableData">
                <div class="lengdeList box">
                    <span class="lengdeName blod innerbox">时间</span>
                    <span class="lengdeName blod innerbox">已发佣金（元）</span>
                    <span class="lengdeName blod innerbox">待发佣金（元）</span>
                </div>
                <div class="box">
                    <span class="innerbox">总汇</span>
                    <span class="innerbox">{{filterSummary.brokeragepayed}}</span>
                    <span class="innerbox">{{filterSummary.brokeragetopay}}</span>
                </div>
                <div v-for="(obj,index) in tableData" :key="index">
                    <div class="box outbox">
                        <span class="innerbox">{{obj.date}}</span>
                        <span class="innerbox">{{obj.brokeragepayed}}</span>
                        <span class="innerbox">{{obj.brokeragetopay}}</span>
                    </div>
                    <div class="box" v-for="(obj2,idx) in obj.headerlist" :key="idx">
                        <span class="innerbox header">{{obj2.headername}}</span>
                        <span class="innerbox header">{{obj2.brokeragepayed}}</span>
                        <span class="innerbox header">{{obj2.brokeragetopay}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getDataAnalysisBrokerageDataByBrand, getDataAnalysisBrokerageData, exportDataAnalysisBrokerageDataByBrand} from 'api/brandBusiness'
export default {
    name: 'CommissionDaily',
    data() {
        return {
            summary: {
                todaybrokeragepayed: '0.00', // 今日已发佣金
                todaybrokeragetotalbyheader: '0.00', // 今日产生佣金
                yesbrokeragepayed: '0.00', // 昨日已发佣金
                yesbrokeragetotalbyheader: '0.00', // 昨日产生佣金
                brokeragetotalbyheader: '0.00', // 产生佣金
                brokeragepayed: '0.00' // 已发佣金
            },
            filterSummary:{
                brokeragepayed: '0.00',
                brokeragetopay: '0.00',
                updatetime: ''
            },
            param: {
                begintime: '',
                endtime: '',
                timetype: 3 //  0自定义 1今日 2昨日 3近7日 4近30日
            },
            lineDatas: {id: 'saleData', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}<br />{a1}: {c1}'},
            date: [],
            tableData: [],
            init: false
        }
    },
    mounted() {
        this._getDataAnalysisBrokerageData()
        this._getDataAnalysisBrokerageDataByBrand()
    },
    methods: {
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.begintime = this.date[0]
                this.param.endtime = this.date[1]
            }
            this.param.timetype = index
            this._getDataAnalysisBrokerageDataByBrand()
        },
        handleExport() {
            this.setLoading(true)
            exportDataAnalysisBrokerageDataByBrand({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '佣金日报' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getDataAnalysisBrokerageData() {
            this.setLoading(true)
            getDataAnalysisBrokerageData({
                data: {},
                success: data => {
                    this.summary = data.data
                    this.init = true
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getDataAnalysisBrokerageDataByBrand() {
            this.setLoading(true)
            getDataAnalysisBrokerageDataByBrand({
                data: Object.assign({}, this.param),
                success: data => {
                    this.tableData = data.data.datalist
                    this.filterSummary = data.data.summary
                    this.lineDatas.xdata = data.data.datelist
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '待发佣金',
                            color: '#5AD8A6',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.nopaylist
                        }
                    )
                    this.lineDatas.data.push(
                        {
                            title: '已发佣金',
                            color: '#5D7092',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.paylist
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.CommissionDaily {

}
</style>
